import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import { FormStateChangeNotifier } from '../form';
import { useIsInForm } from '../utils/useIsInForm';
var AKToggle = /*#__PURE__*/React.lazy(function () {
  return import( /* webpackChunkName: '@atlaskit-internal_.toggle' */
  '@atlaskit/toggle').then(function (module) {
    return {
      default: module.default
    };
  });
});
var AKField = /*#__PURE__*/React.lazy(function () {
  return import( /* webpackChunkName: '@atlaskit-internal_.form' */
  '@atlaskit/form').then(function (module) {
    return {
      default: module.Field
    };
  });
});
var wrapperStyles = css({
  display: 'flex',
  alignItems: 'center'
});
var labelStyles = css({
  cursor: 'pointer'
});
export var Toggle = function Toggle(_ref) {
  var forgeDoc = _ref.forgeDoc;
  var _ref2 = forgeDoc.props,
    defaultChecked = _ref2.defaultChecked,
    name = _ref2.name,
    label = _ref2.label,
    _onChange = _ref2.onChange;
  var _React$useState = React.useState(false || defaultChecked),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    toggleVal = _React$useState2[0],
    setToggleVal = _React$useState2[1];
  var isInForm = useIsInForm();
  if (!isInForm) {
    var handleToggle = function handleToggle() {
      setToggleVal(function (prevVal) {
        _onChange === null || _onChange === void 0 || _onChange(!prevVal);
        return !prevVal;
      });
    };
    return jsx("div", {
      css: wrapperStyles
    }, jsx(AKToggle, {
      name: name,
      isChecked: toggleVal,
      size: "large",
      label: label,
      onChange: handleToggle
    }), jsx("span", {
      css: labelStyles,
      onClick: handleToggle
    }, label));
  }
  return jsx(AKField, {
    defaultValue: defaultChecked,
    name: name
  }, function (_ref3) {
    var fieldProps = _ref3.fieldProps;
    var fieldOnChange = fieldProps.onChange,
      value = fieldProps.value,
      id = fieldProps.id,
      isDisabled = fieldProps.isDisabled,
      onBlur = fieldProps.onBlur,
      onFocus = fieldProps.onFocus,
      toggleName = fieldProps.name;
    return jsx("div", {
      css: wrapperStyles
    }, jsx(FormStateChangeNotifier, {
      name: toggleName,
      value: value
    }), jsx(AKToggle, {
      onChange: function onChange() {
        fieldOnChange(!value);
        _onChange === null || _onChange === void 0 || _onChange(!value);
      },
      isChecked: value,
      size: "large",
      label: label,
      id: id,
      isDisabled: isDisabled,
      onBlur: onBlur,
      onFocus: onFocus,
      name: toggleName
    }), jsx("span", {
      css: labelStyles,
      onClick: function onClick() {
        fieldOnChange(!value);
        _onChange === null || _onChange === void 0 || _onChange(!value);
      }
    }, label));
  });
};